import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KeyCodeWithModifiersyrb06kjwhumy as KeyCodeWithModifiers } from '../models/KeyCode.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Emitter3oauzcbmv9irf as Emitter,
  reactiveProcess2z4nh4eb606pm as reactiveProcess,
} from '../../../../../reactive/com/lightningkite/reactive/core/processes.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_px8ok5q0jdway2 as get_px } from '../models/data.commonHtml.mjs';
import { WindowStatisticscvqq0mhzo3xj as WindowStatistics } from '../models/WindowStatistics.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$reactiveProcess, $completion) {
  var l = (ev) => {
    if (!(ev instanceof KeyboardEvent))
      THROW_CCE();
    $this$reactiveProcess.eaq(new (KeyCodeWithModifiers())(ev.code, ev.altKey, ev.ctrlKey, ev.shiftKey, ev.metaKey));
    return Unit_instance;
  };
  window.addEventListener('keydown', l);
  try {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
    cancellable.ra5();
    var tmp$ret$1 = cancellable.sa5();
    var tmp = returnIfSuspended(tmp$ret$1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }finally {
    window.removeEventListener('keydown', l);
  }
  return Unit_instance;
}
var AppState$_lastUniversalKeyboardInput$slambdaClass;
function AppState$_lastUniversalKeyboardInput$slambda() {
  if (AppState$_lastUniversalKeyboardInput$slambdaClass === VOID) {
    class $ {
      rdo($this$reactiveProcess, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$reactiveProcess), $completion);
      }
      s2(p1, $completion) {
        return this.rdo((!(p1 == null) ? isInterface(p1, Emitter()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    AppState$_lastUniversalKeyboardInput$slambdaClass = $;
  }
  return AppState$_lastUniversalKeyboardInput$slambdaClass;
}
function AppState$_lastUniversalKeyboardInput$slambda_0() {
  var i = new (AppState$_lastUniversalKeyboardInput$slambda())();
  var l = ($this$reactiveProcess, $completion) => i.rdo($this$reactiveProcess, $completion);
  l.$arity = 1;
  return l;
}
var AppStateClass;
function AppState() {
  if (AppStateClass === VOID) {
    class $ {
      constructor() {
        AppState_instance = this;
        var tmp = this;
        // Inline function 'kotlin.also' call
        var this_0 = Signal().fak(new (WindowStatistics())(get_px(window.innerWidth), get_px(window.innerHeight), window.devicePixelRatio));
        var it = this_0;
        var tmp_0 = window;
        tmp_0.addEventListener('resize', (ev) => {
          var newwidth = get_px(window.innerWidth);
          var newheight = get_px(window.innerHeight);
          var tmp;
          if (!equals(it.f2().ebi_1, newwidth) || !equals(it.f2().fbi_1, newheight)) {
            it.mam(new (WindowStatistics())(newwidth, newheight, window.devicePixelRatio));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        tmp.hbi_1 = this_0;
        this.ibi_1 = Signal().fak(false);
        this.jbi_1 = null;
        this.kbi_1 = 0;
        var tmp_1 = this;
        tmp_1.lbi_1 = reactiveProcess(VOID, AppState$_lastUniversalKeyboardInput$slambda_0());
      }
      mbi() {
        return this.hbi_1;
      }
      sdo(handler) {
        var l = (ev) => {
          if (!(ev instanceof KeyboardEvent))
            THROW_CCE();
          var tmp;
          if (handler(new (KeyCodeWithModifiers())(ev.code, ev.altKey, ev.ctrlKey, ev.shiftKey, ev.metaKey))) {
            ev.preventDefault();
            ev.stopImmediatePropagation();
            tmp = Unit_instance;
          }
          return Unit_instance;
        };
        window.addEventListener('keydown', l);
        return () => {
          window.removeEventListener('keydown', l);
          return Unit_instance;
        };
      }
    }
    initMetadataForObject($, 'AppState');
    AppStateClass = $;
  }
  return AppStateClass;
}
var AppState_instance;
function AppState_getInstance() {
  if (AppState_instance === VOID)
    new (AppState())();
  return AppState_instance;
}
//region block: exports
export {
  AppState_getInstance as AppState_getInstance1lcg5jamx8e1g,
};
//endregion

//# sourceMappingURL=AppState.js.mjs.map
